module.exports = __webpack_public_path__ + "static/media/companyAvatar.f097ea47.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/companyAvatar.png
// module id = 405
// module chunks = 0